import React, { useState, useEffect, useRef } from 'react';
import { X, Star, Play, ChevronLeft, ChevronRight, Camera, Film } from 'lucide-react';

// Gallery items with real photos and videos
const galleryItems = [
  {
    id: 1,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/0d7eezdt_WhatsApp%20Image%202026-01-06%20at%201.47.31%20PM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/0d7eezdt_WhatsApp%20Image%202026-01-06%20at%201.47.31%20PM.jpeg',
    title: 'Industrial Equipment Transport',
    category: 'Projects'
  },
  {
    id: 2,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/15zfg1g2_WhatsApp%20Image%202026-01-27%20at%203.47.06%20PM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/15zfg1g2_WhatsApp%20Image%202026-01-27%20at%203.47.06%20PM.jpeg',
    title: 'Warehouse Loading Operations',
    category: 'Projects'
  },
  {
    id: 3,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/qx9hjm3l_WhatsApp%20Image%202026-02-02%20at%209.16.24%20AM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/qx9hjm3l_WhatsApp%20Image%202026-02-02%20at%209.16.24%20AM.jpeg',
    title: 'Furniture Delivery Service',
    category: 'Tailgate'
  },
  {
    id: 4,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/45aubff3_WhatsApp%20Image%202026-02-02%20at%2011.01.59%20AM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/45aubff3_WhatsApp%20Image%202026-02-02%20at%2011.01.59%20AM.jpeg',
    title: 'Professional Unloading Service',
    category: 'Manpower'
  },
  {
    id: 31,
    type: 'image',
    url: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/551hr9yw_image.png',
    thumbnail: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/551hr9yw_image.png',
    title: 'Low-Bed Trailer — Road Milling Machine Transport',
    category: 'Trailer',
    featured: true
  },
  {
    id: 5,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/anzx7yqt_WhatsApp%20Image%202026-02-07%20at%209.36.54%20AM%20%282%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/anzx7yqt_WhatsApp%20Image%202026-02-07%20at%209.36.54%20AM%20%282%29.jpeg',
    title: 'Forklift Loading Operations',
    category: 'Trailer'
  },
  {
    id: 6,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/ulue87bd_IMG_1392.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/ulue87bd_IMG_1392.jpeg',
    title: 'SCANIA Trailer - Material Transport',
    category: 'Trailer'
  },
  {
    id: 7,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/wtdnh15h_IMG_1393.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/wtdnh15h_IMG_1393.jpeg',
    title: 'Heavy Load Trailer in Operation',
    category: 'Trailer'
  },
  {
    id: 8,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/88t1jlbm_IMG_1394.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/88t1jlbm_IMG_1394.jpeg',
    title: 'Loading Operations with Forklift',
    category: 'Projects'
  },
  {
    id: 9,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/z6lk0xyi_IMG_1395.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_logistics-hub-200/artifacts/z6lk0xyi_IMG_1395.jpeg',
    title: 'Professional Loading Service',
    category: 'Projects'
  },
  {
    id: 10,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/isowump2_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/isowump2_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM.jpeg',
    title: 'Container Loading with Crane Truck',
    category: 'Projects'
  },
  {
    id: 11,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/93g3yv1x_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2810%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/93g3yv1x_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2810%29.jpeg',
    title: 'Crane Lifting Structural Components',
    category: 'Projects'
  },
  {
    id: 12,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/pxn9u7t0_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2811%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/pxn9u7t0_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2811%29.jpeg',
    title: 'Heavy Component Transport & Lifting',
    category: 'Projects'
  },
  {
    id: 13,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/tkjmjxg5_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2812%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/tkjmjxg5_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2812%29.jpeg',
    title: 'Industrial Cargo Crane Operations',
    category: 'Projects'
  },
  {
    id: 14,
    type: 'video',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/d63hwacx_WhatsApp%20Video%202026-04-09%20at%2010.29.48%20AM.mp4',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/93g3yv1x_WhatsApp%20Image%202026-04-09%20at%2010.28.20%20AM%20%2810%29.jpeg',
    title: 'Logistics Operations in Action',
    category: 'Projects'
  },
  {
    id: 15,
    type: 'video',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/5ox6s300_WhatsApp%20Video%202026-04-14%20at%206.16.09%20PM.mp4',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/aucspla3_image.png',
    title: 'Heavy Lifting Service & Lifting Team',
    category: 'Projects'
  },
  {
    id: 16,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/kmswsfn4_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/kmswsfn4_image.png',
    title: 'Heavy Tanks Lifting',
    category: 'Projects'
  },
  {
    id: 17,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/cxdpr853_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/cxdpr853_image.png',
    title: 'Lifting Team',
    category: 'Projects'
  },
  {
    id: 18,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ueofg80s_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ueofg80s_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM.jpeg',
    title: 'On-Site Operations',
    category: 'Projects',
    featured: true
  },
  {
    id: 19,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ky05regt_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM%20%281%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ky05regt_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM%20%281%29.jpeg',
    title: 'Heavy Equipment Handling',
    category: 'Projects',
    featured: true
  },
  {
    id: 20,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/damc6bse_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM%20%282%29.jpeg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/damc6bse_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM%20%282%29.jpeg',
    title: 'Logistics in Action',
    category: 'Projects',
    featured: true
  },
  {
    id: 21,
    type: 'video',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/kycm99sa_WhatsApp%20Video%202026-05-22%20at%202.32.15%20PM.mp4',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/damc6bse_WhatsApp%20Image%202026-05-18%20at%2011.00.55%20AM%20%282%29.jpeg',
    title: 'Crane Operation in Progress',
    category: 'Projects',
    featured: true
  },
  {
    id: 22,
    type: 'video',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/6c9dt0r6_Seletar%20Aerospeace%20video.mp4',
    thumbnail: '/thumbnails/seletar_aerospace_1.jpg',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 23,
    type: 'video',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/qbihirch_Seletar%20Aerospeace%20video.1%20.mp4',
    thumbnail: '/thumbnails/seletar_aerospace_2.jpg',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 24,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/xv7ahav9_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/xv7ahav9_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 25,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/oljsdpg2_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/oljsdpg2_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 26,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/6p5cfllq_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/6p5cfllq_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 27,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/dhutj4id_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/dhutj4id_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 28,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/fnfszscw_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/fnfszscw_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 29,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/mxv4kf7w_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/mxv4kf7w_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  },
  {
    id: 30,
    type: 'image',
    url: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ka95qwwl_image.png',
    thumbnail: 'https://customer-assets.emergentagent.com/job_6ad06afe-da3b-46ca-832e-3147a77af072/artifacts/ka95qwwl_image.png',
    title: 'Project at Seletar Aerospace',
    category: 'Projects',
    featured: true
  }
];

// Rotating carousel for the Featured section
const FeaturedCarousel = ({ items, onSelect }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = items.length;

  useEffect(() => {
    if (paused || total <= 1) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, 5000);
    return () => clearInterval(t);
  }, [paused, total]);

  const next = () => setIndex((i) => (i + 1) % total);
  const prev = () => setIndex((i) => (i - 1 + total) % total);

  if (total === 0) return null;
  const current = items[index];

  return (
    <div
      className="relative max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-2xl group bg-gray-900"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="featured-carousel"
    >
      {/* Slides */}
      <div className="relative aspect-[16/9] md:aspect-[21/9]">
        {items.map((item, i) => (
          <div
            key={item.id}
            onClick={() => onSelect(item)}
            className={`absolute inset-0 transition-opacity duration-1000 cursor-pointer ${
              i === index ? 'opacity-100 z-10' : 'opacity-0 z-0'
            }`}
            data-testid={`carousel-slide-${i}`}
          >
            <img src={item.thumbnail} alt={item.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute top-4 left-4 bg-gold text-burgundy-deep text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow">
              <Star size={12} className="fill-current" /> Featured
            </div>
            {item.type === 'video' && (
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="bg-white/90 rounded-full p-5 shadow-2xl">
                  <Play className="text-burgundy" size={36} fill="currentColor" />
                </div>
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <p className="text-white/80 text-xs md:text-sm uppercase tracking-widest mb-1">{item.category}</p>
              <h3 className="text-white text-2xl md:text-3xl font-bold">{item.title}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* Controls */}
      <button
        onClick={prev}
        className="absolute left-3 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
        aria-label="Previous"
        data-testid="carousel-prev"
      >
        <ChevronLeft className="text-gray-800" size={24} />
      </button>
      <button
        onClick={next}
        className="absolute right-3 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
        aria-label="Next"
        data-testid="carousel-next"
      >
        <ChevronRight className="text-gray-800" size={24} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {items.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all ${
              i === index ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

// Animated wrapper that triggers fade-in + slide-up when scrolled into view
const FeaturedTile = ({ item, index, onClick }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      onClick={onClick}
      className={`relative aspect-square rounded-xl overflow-hidden shadow-md hover:shadow-xl cursor-pointer group transition-all duration-700 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${index * 120}ms` }}
      data-testid={`featured-item-${item.id}`}
    >
      <img
        src={item.thumbnail}
        alt={item.title}
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
      />
      <div className="absolute top-2 left-2 bg-gold text-burgundy-deep text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1 shadow">
        <Star size={10} className="fill-current" /> Featured
      </div>
      {item.type === 'video' && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30">
          <div className="bg-white/90 rounded-full p-3 group-hover:scale-110 transition-transform">
            <Play className="text-burgundy" size={24} fill="currentColor" />
          </div>
        </div>
      )}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
        <p className="text-white text-sm font-semibold">{item.title}</p>
      </div>
    </div>
  );
};

const categories = ['All', 'Trailer', 'Tailgate', 'Manpower', 'Warehouse', 'Projects'];

export const Gallery = () => {
  const [mediaTab, setMediaTab] = useState('photos'); // 'photos' | 'videos'
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedItem, setSelectedItem] = useState(null);

  const featuredItems = galleryItems.filter(item => item.featured);
  const tabItems = galleryItems.filter(item =>
    mediaTab === 'photos' ? item.type === 'image' : item.type === 'video'
  );
  const filteredItems = selectedCategory === 'All'
    ? tabItems
    : tabItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-burgundy-deep">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-burgundy-dark grain-overlay relative">
        <div className="container mx-auto relative z-10">
          <p className="text-gold text-xs font-semibold uppercase tracking-[0.3em] mb-4">Our Work</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-4">
            Gallery
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl">
            Explore our fleet, projects, and team in action
          </p>
        </div>
      </section>

      {/* Featured Highlights */}
      {featuredItems.length > 0 && (
        <section className="py-12 px-4">
          <div className="container mx-auto">
            <div className="flex items-center justify-center gap-2 mb-6">
              <Star className="text-gold fill-gold" size={22} />
              <h2 className="font-display text-2xl md:text-3xl font-bold text-white tracking-tight">Featured Highlights</h2>
              <Star className="text-gold fill-gold" size={22} />
            </div>
            <p className="text-center text-white/60 mb-8">Our latest projects and team in action</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {featuredItems.map((item, idx) => (
                <FeaturedTile
                  key={`featured-${item.id}`}
                  item={item}
                  index={idx}
                  onClick={() => setSelectedItem(item)}
                />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Media Tabs (Photos / Videos) */}
      <section className="pt-8 px-4">
        <div className="container mx-auto">
          <div className="flex justify-center gap-2 border-b border-gold/15">
            <button
              onClick={() => { setMediaTab('photos'); setSelectedCategory('All'); }}
              className={`px-8 py-3 text-base font-semibold transition-all border-b-2 -mb-px ${
                mediaTab === 'photos'
                  ? 'text-gold border-gold'
                  : 'text-white/50 border-transparent hover:text-white'
              }`}
              data-testid="tab-photos"
            >
              <Camera size={17} className="inline mr-2 -mt-0.5" />Photos
            </button>
            <button
              onClick={() => { setMediaTab('videos'); setSelectedCategory('All'); }}
              className={`px-8 py-3 text-base font-semibold transition-all border-b-2 -mb-px ${
                mediaTab === 'videos'
                  ? 'text-gold border-gold'
                  : 'text-white/50 border-transparent hover:text-white'
              }`}
              data-testid="tab-videos"
            >
              <Film size={17} className="inline mr-2 -mt-0.5" />Videos
            </button>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 px-4 border-b border-gold/15">
        <div className="container mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-gold text-burgundy-deep shadow-md'
                    : 'bg-white/10 text-white/70 hover:bg-white/20'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-300"
                onClick={() => setSelectedItem(item)}
              >
                {item.type === 'video' ? (
                  <video
                    src={`${item.url}#t=0.5`}
                    muted
                    preload="auto"
                    playsInline
                    poster={item.thumbnail}
                    onLoadedData={(e) => { e.target.currentTime = 0.5; }}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                ) : (
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                )}
                {item.type === 'video' && (
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="bg-burgundy/80 rounded-full p-4 group-hover:bg-burgundy-light/90 transition-colors">
                      <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-white font-semibold text-lg mb-1">{item.title}</p>
                    <p className="text-gold-light text-sm">{item.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">No items found in this category</p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedItem && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setSelectedItem(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedItem(null)}
          >
            <X size={32} />
          </button>
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            {selectedItem.type === 'video' ? (
              <video
                src={selectedItem.url}
                className="w-full max-h-[80vh] rounded-lg"
                controls
                autoPlay
                playsInline
              />
            ) : (
              <img
                src={selectedItem.url}
                alt={selectedItem.title}
                className="w-full h-auto rounded-lg"
              />
            )}
            <div className="text-center mt-4">
              <h3 className="text-white text-2xl font-semibold">{selectedItem.title}</h3>
              <p className="text-gold-light mt-2">{selectedItem.category}</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 md:py-24 px-4 bg-burgundy-dark grain-overlay relative">
        <div className="container mx-auto text-center relative z-10">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
            Want to See Our Equipment in Person?
          </h2>
          <p className="text-white/70 text-base md:text-lg mb-9 max-w-2xl mx-auto">
            Contact us to schedule a visit or book our services for your next project
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="/contact">
              <button className="bg-gold text-burgundy-deep font-semibold uppercase tracking-[0.1em] text-sm px-8 py-4 rounded-md hover:bg-gold-light transition-colors">
                Contact Us
              </button>
            </a>
            <a href="/booking">
              <button className="border border-white/40 text-white font-medium uppercase tracking-[0.1em] text-sm px-8 py-4 rounded-md hover:bg-white hover:text-burgundy-deep transition-colors">
                Book Now
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
